export enum PointRank {
  EXPLORER = 'explorer',
  PATHFINDER = 'pathfinder',
  OPEN_SOURCERER = 'open-sourcerer-orange',
  SUPER_SOURCERER = 'open-sourcerer-gold',
}
